import React from 'react';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ModuleCircle from './components/ModuleCircle';
import Line from './components/Line';
import ModulePopover from './components/ModulePopover';
import RecoveryClock from '../RecoveryPlan/components/RecoveryClock';
// hoc
import { withRouter } from 'react-router-dom';
// shapes
import dashboard from '../../shapes/dashboard';
// styles
import styles from './Dashboard.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const DesktopDashboard = ({
  getModuleState,
  currentModule,
  currentProgress,
  modules,
  relapseModule,
  role,
  relapseAccess,
  skillsAccess,
  history,
  dailyAccess,
  weeklyAccess,
  monthlyAccess,
  location,
}) => {
  const isClient = role === 'client';
  const state = location.state || {};
  return (
    <PageWrapper centered className={cx('dashboard')}>
      <h2 className="mb-10">Dashboard</h2>
      <RecoveryClock />

      <div className={cx('main-modules')}>
        {'012345678'.split('').map((num, index) => {
          const moduleState = getModuleState(num);
          return (
            <ModulePopover
              moduleIndex={num}
              key={index}
              initialOpen={+num === state.id}
              module={modules[index] || modules[0]}
              state={moduleState}
              isClient={isClient}
            >
              <ModuleCircle
                name={num}
                className={cx('main-module')}
                state={moduleState}
                progress={currentProgress}
              />
            </ModulePopover>
          );
        })}
        <div className={cx('connectors')}>
          {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
            <Line
              type="curve"
              className={cx('curve')}
              solid={num < currentModule}
              key={num}
            />
          ))}
        </div>
      </div>

      {isClient && (
        <div className={cx('extra-modules')}>
          <div className={cx('extra-module-wrapper')}>
            <ModuleCircle
              iconType="comment"
              name="Journal"
              onClick={() => {
                history.push('/journal');
              }}
              className={cx('extra-module')}
              state="extra"
            />
          </div>
          {relapseAccess && (
            <div className={cx('extra-module-wrapper')}>
              <ModulePopover
                moduleIndex={'relapsemodule'}
                initialOpen={state.id === 'R'}
                trigger="click"
                isClient={isClient}
                module={relapseModule}
                state="extra"
              >
                <ModuleCircle
                  iconType="chevron-double-up"
                  name="Relapse"
                  className={cx('extra-module')}
                  state="extra"
                />
              </ModulePopover>
            </div>
          )}
          {skillsAccess && (
            <div className={cx('extra-module-wrapper')}>
              <ModuleCircle
                onClick={() => {
                  history.push('/skills');
                }}
                iconType="calendar-alt"
                name="Skills"
                className={cx('extra-module')}
                state="extra"
              />
            </div>
          )}
          {dailyAccess && (
            <div className={cx('extra-module-wrapper')}>
              <ModuleCircle
                onClick={() => {
                  history.push('/daily-check-in');
                }}
                secondary
                iconType="check-circle"
                name="Daily check-in"
                className={cx('extra-module', 'secondary')}
                state="extra"
              />
            </div>
          )}
          {weeklyAccess && (
            <div className={cx('extra-module-wrapper')}>
              <ModuleCircle
                onClick={() => {
                  history.push('/weekly-check-in');
                }}
                secondary
                iconType="check-circle"
                name="Weekly check-in"
                className={cx('extra-module', 'secondary')}
                state="extra"
              />
            </div>
          )}
          {monthlyAccess && (
            <div className={cx('extra-module-wrapper')}>
              <ModuleCircle
                onClick={() => {
                  history.push('/monthly-check-in');
                }}
                secondary
                iconType="calendar-check"
                name="Monthly check-in"
                className={cx('extra-module', 'secondary')}
                state="extra"
              />
            </div>
          )}
        </div>
      )}
    </PageWrapper>
  );
};

DesktopDashboard.propTypes = dashboard;

export default withRouter(DesktopDashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DesktopDashboard.jsx